export function testURL(url){
  //regex je identican kao na serveru
const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

if (url.match(urlRegex)) {
  return true;
}
  return false;
}